import { z } from 'zod';

import { GamePlatformSchema } from './game.js';

// Stores a game can publish to. Stable string keys; display labels and
// per-platform availability live in constants/publishing-stores.ts.
export const PublishingStoreSchema = z.enum([
  'steam',
  'epic',
  'gog',
  'itch_io',
  'mac_app_store',
  'app_store',
  'google_play',
  'nintendo',
  'playstation',
  'xbox',
  'meta_horizon',
]);
export type PublishingStore = z.infer<typeof PublishingStoreSchema>;

export const PublishingDestinationSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  platform: GamePlatformSchema,
  store: PublishingStoreSchema,
  // Freeform per the story; format validation is explicitly out of scope.
  storeUrl: z.string().nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type PublishingDestination = z.infer<typeof PublishingDestinationSchema>;
